<template>
<v-form ref="form2" data-vv-scope="form2">
    <v-container grid-list-md>
        <v-layout wrap>
            <v-flex xs12 sm12 md12>
                <v-text-field class="required" prepend-icon="fa fa-credit-card-alt" :append-icon="creditcardNumber" autofocus :mask="masks.credit_card" v-model="credit_card.number" v-validate="'credit_card|required'" :error-messages="errors.collect('credit_card.number')"
                    :label="$t('message.number')" data-vv-name="credit_card.number" @keyup.13="validateForm('form2')" data-vv-validate-on="blur" required>
                    <template slot="append-outer" name="full_name_slot">
                        <v-icon v-show="credit_card.number===undefined?true:(credit_card.number.length>0?false:true)">fa fa-asterisk</v-icon>
                    </template>
                </v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
                <v-text-field class="required" prepend-icon="fa fa-eye-slash" return-masked-value mask="####" v-model="credit_card.security_code" v-validate="'required|min:3'" :error-messages="errors.collect('credit_card.security_code')" :label="$t('message.security_code')"
                    data-vv-name="credit_card.security_code" @keyup.13="validateForm('form2')"  data-vv-validate-on="blur" required>
                    <template slot="append-outer" name="full_name_slot">
                        <v-icon v-show="credit_card.security_code===undefined?true:(credit_card.security_code.length>0?false:true)">fa fa-asterisk</v-icon>
                    </template>
                </v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
                <v-text-field class="required" prepend-icon="fa fa-calendar" return-masked-value mask="####/##" placeholder="YYYY/MM" v-model="credit_card.expiration_date" v-validate="'date_format:yyyy/MM|dateBetween|required'" :error-messages="errors.collect('credit_card.expiration_date')"
                    :label="$t('message.expiration_date')" data-vv-name="credit_card.expiration_date" @keyup.13="validateForm('form2')" data-vv-validate-on="blur" required>
                    <template slot="append-outer" name="full_name_slot">
                        <v-icon v-show="credit_card.expiration_date===undefined?true:(credit_card.expiration_date.length>0?false:true)">fa fa-asterisk</v-icon>
                    </template>
                </v-text-field>
            </v-flex>
        </v-layout>
    </v-container>
</v-form>
</template>

<script>
import {
    EventBus
} from './EventBus.js';
import cards from './../resources/cards'

export default {
    watch: {
        'credit_card.number'(){
            if (this.errors.has('credit_card.number')) {
              this.errors.remove('credit_card.number')
            }
        },
        'credit_card.security_code'(){
            if (this.errors.has('credit_card.security_code')) {
              this.errors.remove('credit_card.security_code')
            }
        },
        'credit_card.expiration_date'(){
            if (this.errors.has('credit_card.expiration_date')) {
              this.errors.remove('credit_card.expiration_date')
            }
        },
    },
    data() {
        return {
            icon_name: '',
            masks: {
                credit_card: 'credit-card',
            },
            credit_card: {
                number: '',
                security_code: '',
                expiration_date: '',
                paymentMethod: '',
            },
            dictionary: {
                attributes: {
                    'credit_card.number': 'Number',
                    'credit_card.security_code': 'Security code',
                    'credit_card.expiration_date': 'Expiration date',
                    // custom attributes
                },
            },
            cards: cards,
        }
    },
    mounted() {
        EventBus.$on('resetForm2', this.reset);
    },
    created() {
        EventBus.$on('next', this.validateForm);

        let date = new Date();
        this.$validator.extend('dateBetween', {
            getMessage(field, val) {
                return `You must enter a valid expiration date`
            },
            validate(value, field) {
                let start = `${date.getFullYear()}/0${date.getMonth()}`; // month is 0-based
                let end = `${date.getFullYear()+15}/12}`;
                return value > start && value < end;
            }
        });
    },
    computed: {
        creditcardNumber() {
            return this.cardFromNumber(this.credit_card.number) !== undefined ? this.cardFromNumber(this.credit_card.number) : 'fa fa-credit-card';
        },
    },
    methods: {
        validateForm(scope) {
            if (scope == 'form2') {
                console.log(`${scope} == 'form2'`)
                this.$validator.validateAll(scope).then(res => {
                    if (res) {
                        this.$emit('submit', {
                            form: 'form2',
                            credit_card: this.credit_card
                        });
                    }
                });
            }
        },
        reset() {
            if (this.$refs.form2 !== undefined) {
                console.log('credit card defined');
                this.$refs.form2.reset();
            }
            this.$validator.reset();
        },
        cardFromNumber(number) {
            let card2return;
            let _this = this;
            this.cards.map( card => {
                if (card.pattern.test(number)) {
                    card2return =  card.css;
                    _this.credit_card.paymentMethod = card.type;
                }
            });
            return card2return;
        }
    }
}
</script>
<style>
.fa-asterisk:before{
  color:red;
  font-size: .35em;
}
/* .v-input__icon--append {
    margin-right: 5px !important;
} */
</style>
